import { render, staticRenderFns } from "./YapiRuhsatListesi.vue?vue&type=template&id=1f515b5c&scoped=true&"
import script from "./YapiRuhsatListesi.vue?vue&type=script&lang=js&"
export * from "./YapiRuhsatListesi.vue?vue&type=script&lang=js&"
import style0 from "./YapiRuhsatListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YapiRuhsatListesi.vue?vue&type=style&index=1&id=1f515b5c&lang=scss&scoped=true&"
import style2 from "./YapiRuhsatListesi.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./YapiRuhsatListesi.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f515b5c",
  null
  
)

export default component.exports